// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"296":"53b81f59","613":"c7dd23e4"}[chunkId] + ".chunk.css";
};